import script from "./NavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavItem.vue?vue&type=script&setup=true&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=4ae8458e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae8458e"]])

export default __exports__